<template>
  <div class="Risk">
    <!-- 当前位置 -->
    <div class="box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <span class="dangqian">当前位置：</span>
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="red">社会责任</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 布局容器 -->
    <div class="container">
      <!-- 左侧 -->
      <div class="left">
        <div class="top">
          <i class="iconfont iconbianzu10beifen3"></i>
          <p class="yi">社会责任</p>
        </div>
        <div
          class="smallBox"
          v-for="item in tabList"
          :key="item.id"
          :class="{ isActive: item.id == activeId }"
          @click="handle(item.id)"
        >
          {{ item.job }}
        </div>
      </div>
      <!-- 右侧 -->
      <div class="right">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeId: 1,
      tabPosition: "left",
      tabList: [
        { id: 1, job: "社会责任实践" },
        { id: 2, job: "公益慈善" },
      ],
    };
  },
  methods: {
    handle(id) {
      if (id == 1) {
        this.activeId = 1;
        this.$router.push({ name: "SiXiang" });
      } else if (id == 2) {
        this.activeId = 2;
        this.$router.push({ name: "ZhiDu" });
      } else if (id == 3) {
        this.activeId = 3;
        this.$router.push({ name: "ZhiZe" });
      }
    },
  },
  mounted() {
    let router_path = this.$route.path;

    if (router_path === "/Risk/ZhiDu") {
      this.activeId = 2;
    }
  },
};
</script>
<style lang="less" scoped>
.Risk {
  background: #f2f2f2;
  width: 80%;
  margin: 0 auto;
  margin-bottom: 40px;
}
.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  // margin-top: 20px;
}
.box {
  width: 100%;
}
/deep/ .el-breadcrumb {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 12px;
  float: left;
}
.dangqian {
  float: left;
}
/deep/.el-breadcrumb__inner {
  font-weight: 400 !important;
}
.red {
  color: #00345e;
}

.isActive {
  background: #fce9ea;
}
.left {
  width: 12%;
  height: 180px;
  background-color: white;
}
.smallBox {
  width: 100%;
  height: 52px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 52px;
  text-align: center;
}
.top {
  margin-top: 24px;
  width: 100%;
  height: 52px;
  line-height: 52px;
  display: flex;
  justify-content: flex-start;
  background-color: #00345e;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.yi {
  margin-left: 10px;
  line-height: 34px;
  font-size: 18px;
  color: white;
}
.right {
  margin-left: 20px;
  width: 88%;
  min-height: 712px;
  background-color: white;
  padding: 41px 40px;
  box-sizing: border-box;
}
.yi {
  margin-left: 10px;
  line-height: 50px;
  font-size: 16px;
  color: white;
}
i {
  margin-left: 10px;
  width: 18px;
  height: 18px;
  color: white;
}

/deep/.el-breadcrumb {
  margin: 15px 0 20px 0;
  display: flex;
  align-items: center;
  line-height: 10px;
}
</style>
